<template>
<div>
<v-form
   ref="form"
   v-model="valid"
   @submit.prevent="submit"
>
<v-container fluid class="mb-5">
    <v-row justify="space-between">
      <v-col cols="12" class="text-left">

        <template v-if="!edit_mode">
        <v-btn color="" class="mr-5" @click="$router.go(-1)">
            戻る</v-btn>
        <v-btn type="submit" color="" class="white--text mygreen">
            登録</v-btn>
      </template>
      <template v-else>
                <v-btn color="" class="mr-5" @click="$router.go(-1)">
                    戻る</v-btn>
                <v-btn @click="update" color="" class="mr-5 mygreen" dark>
                    更新</v-btn>

                <DialogYoyakuDelete @delete-item="deleteItemConfirm"></DialogYoyakuDelete>
      </template>

      </v-col>
    </v-row>
  </v-container>

  <v-card class="pa-4 pb-10 mycard">
    <v-container fluid class="myform">

        <v-row>
            <v-col  cols="2" class="text-left">
                <h3 class="">来院情報登録</h3>
            </v-col>
            <v-col cols="1" align-self="center"></v-col>
            <v-col cols="9" class="text-left btn_group" align-self="center">
                  <!-- 患者検索ボタン -->
                  <DialogPatientSearch @search="catchFromDialog" :_unit="unit_selected" :_start="start_selected" :_end="end_selected" :_date="date_selected"></DialogPatientSearch>
                  <DialogMonshinnaiyou :is_showBtn="true" :reserve_id="reserve_id"  @submit_monshin="submit_monshin"></DialogMonshinnaiyou>

                  <DialogSyochinaiyou  :is_showBtn="true"  :reserve_id="reserve_id" @submit_syochi="submit_syochi"></DialogSyochinaiyou>
            </v-col>
        </v-row>


      <v-row>
        <v-col cols="2" class="text-left" align-self="center">
            <div>受付・予約日時</div>
        </v-col>
        <v-col cols="1" align-self="center">
            <v-chip
            label
            outlined
            color="red"
            >必須</v-chip>
        </v-col>
        <v-col cols="6" align-self="end" class="pt-11">
            <v-row justify="start">

                <!-- 日付選択 -->
                <v-col cols="4">
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date_selected"
                        outlined
                        append-icon="mdi-calendar-month"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="date_selected"
                        @input="menu1 = false"
                        color="green lighten-1"
                        :no-title="true"
                        locale="jp-ja"
                        :day-format="date => new Date(date).getDate()"
                    ></v-date-picker>
                  </v-menu>
                </v-col>


                <!-- 開始時間選択 -->
                <v-col cols="3" class="">
                    <v-select dense
                        v-model="start_selected"
                        :items="start"
                        outlined
                        placeholder="選択してください"
                         :rules="[v => !!v || '必須項目です.']"
                        append-icon="mdi-clock-time-four-outline"
                    ></v-select>
                </v-col>

                <v-col cols="1" class="pa-0" style="max-width:5%;"><div style="font-size:20px;padding: 20px 0px;">～</div></v-col>
                <!-- 終了時間選択 -->
                <v-col cols="3" class="">
                    <v-select dense
                        v-model="end_selected"
                        :items="end"
                        outlined
                        no-data-text="先に開始時間を選択してください."
                        placeholder="選択してください"
                         :rules="[v => !!v || '必須項目です.']"
                         @click="endSelect()"
                        append-icon="mdi-clock-time-four-outline"
                    ></v-select>
                </v-col>

            </v-row>
        </v-col>
        <v-col cols="3"></v-col>
      </v-row>

      <v-row>
        <v-col cols="2" class="text-left" align-self="center">
            <div>ユニット</div>
        </v-col>
        <v-col cols="1" align-self="center">
            <v-chip
            label
            outlined
            color="red"
            >必須</v-chip>
        </v-col>
        <v-col cols="3" align-self="end" class="pt-11">
            <v-select
                v-model="unit_selected"
                :items="unit"
                outlined
                placeholder="選択してください"
                 :rules="[v => !!v || '必須項目です.']"
            ></v-select>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2" class="text-left" align-self="center">
            <div>ステータス</div>
        </v-col>
        <v-col cols="1" align-self="center">
        </v-col>
        <v-col cols="3" align-self="end" class="pt-11">
            <v-select
                v-model="status_selected"
                :items="status"
                outlined
                placeholder="選択してください"
            ></v-select>
        </v-col>
      </v-row>


      <v-row>
        <v-col cols="2" class="text-left" align-self="center">
            <div>診察券NO</div>
        </v-col>
        <v-col cols="1" align-self="center">
        </v-col>
        <v-col cols="3" class="pt-11">
            <v-text-field
            v-model="bangou"
            color="#8CC11E"
            label="診察券番号"
            outlined></v-text-field>
        </v-col>
        <v-col cols="6"> </v-col>
      </v-row>

        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>患者名(漢字)</div>
            </v-col>
            <v-col cols="1" align-self="center">
                <v-chip label outlined color="red">必須</v-chip>
            </v-col>
            <v-col cols="2" class="pt-11">
                <v-text-field v-model="sei" label="姓" outlined :rules="[v => !!v || '必須項目です.']"></v-text-field>
            </v-col>
            <v-col cols="2" class="pt-11">
                <v-text-field v-model="mei" label="名" outlined :rules="[v => !!v || '必須項目です.']"></v-text-field>
            </v-col>
        </v-row>


        <v-row>
            <v-col cols="2" class="text-left" align-self="center">
                <div>患者名(カナ)</div>
            </v-col>
            <v-col cols="1" align-self="center">
                <v-chip label outlined color="red">必須</v-chip>
            </v-col>
            <v-col cols="2" class="pt-11">
                <v-text-field
                v-model="sei_kana"
                label="セイ"
                :rules="[v => !!v || '必須項目です.']"
                outlined></v-text-field>
            </v-col>
            <v-col cols="2" class="pt-11">
                <v-text-field
                v-model="mei_kana"
                label="メイ"
                :rules="[v => !!v || '必須項目です.']"
                outlined></v-text-field>
            </v-col>
        </v-row>


      <v-row>
        <v-col cols="2" class="text-left" align-self="center">
            <div>性別</div>
        </v-col>
        <v-col cols="1" align-self="center"></v-col>
        <v-col cols="6" align-self="end" class="pt-11">

                            <v-radio-group
                            v-model="sex"
                            row
                            mandatory
                            class="d-flex align-center mb-4"
                            >
                                <v-radio
                                    color="#8CC11E" 
                                    label="男性"
                                    value="M"
                                ></v-radio>
                                <v-radio
                                    color="#8CC11E" 
                                    label="女性"
                                    value="F"
                                ></v-radio>
                            </v-radio-group>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2" class="text-left" align-self="center">
            <div>生年月日</div>
        </v-col>
        <v-col cols="1" align-self="center">
        </v-col>
        <v-col cols="6" align-self="center" class="pt-11">
            <v-row justify="start">

                <!-- 日付選択 -->
                <v-col cols="4">
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="birthday"
                        outlined
                        append-icon="mdi-calendar-month"
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        color="green lighten-1"
                        v-model="birthday"
                        @input="menu2 = false"
                        :no-title="true"
                        locale="jp-ja"
                        :day-format="date => new Date(date).getDate()"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
            </v-row>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="2" class="text-left" align-self="center">
            <div>固定電話番号</div>
        </v-col>
        <v-col cols="1" align-self="center">
        </v-col>
        <v-col cols="3" align-self="end" class="pt-11">
                            <v-text-field
                            v-model="tel"
                            label="0312345678"
                            outlined></v-text-field>
        </v-col>
      </v-row>


      <v-row>
        <v-col cols="2" class="text-left" align-self="center">
            <div>携帯電話番号</div>
        </v-col>
        <v-col cols="1" align-self="center">
        </v-col>
        <v-col cols="3" align-self="end" class="pt-11">
                            <v-text-field
                            v-model="phone"
                            label="0312345678"
                            outlined></v-text-field>
        </v-col>
      </v-row>


      <v-row>
        <v-col cols="2" class="text-left" align-self="center">
            <div>メールアドレス</div>
        </v-col>
        <v-col cols="1" align-self="center">
        </v-col>
        <v-col cols="4" class="pt-11">
            <v-text-field
            v-model="mail"
            label="メールアドレス"
            outlined></v-text-field>
        </v-col>
      </v-row>


      <v-row>
        <v-col cols="2" class="text-left" align-self="center">
            <div>担当医</div>
        </v-col>
        <v-col cols="1" align-self="center">
            <v-chip
            label
            outlined
            color="red"
            >必須</v-chip>
        </v-col>
        <v-col cols="3" align-self="end" class="pt-11">
            <v-select
                v-model="tantou_selected"
                :items="dic_doctor"
                item-text="doctor"
                item-value="id"
                outlined
                placeholder="未選択"
                :rules="[v => !!v || '必須項目です.']"
            ></v-select>
        </v-col>
      </v-row>


      <v-row>
        <v-col cols="2" class="text-left pt-11" align-self="start">
            <div>メモ</div>
        </v-col>
        <v-col cols="1"></v-col>
        <v-col cols="6" align-self="end" class="pt-11">
                            <v-textarea
                            label="メモ"
                            v-model="memo"
                            rows="5"
                            outlined></v-textarea>
        </v-col>
      </v-row>

    </v-container>
  </v-card>
</v-form>


<template>
  <div class="text-center">
    <v-snackbar
      v-model="snackbar"
      timeout="2000"
      vertical
      top
      right
      outlined
    >
      <div v-html="snackbar_text"></div>
      <template v-slot:action="{  }">
        <img @click="snackbar = false" class="img" src="/img/x.svg" style="cursor:pointer;" />
      </template>
    </v-snackbar>
  </div>
</template>

</div>
</template>

<script>
// @ is an alias to /src
/* eslint-disable */
import mycolor from '@/mycolor.js';
import axios from 'axios';
import {mapGetters} from 'vuex';
import DialogPatientSearch from '@/components/DialogPatientSearch.vue';
import DialogMonshinnaiyou from '@/components/DialogMonshinnaiyou.vue';
import DialogSyochinaiyou from '@/components/DialogSyochinaiyou.vue';
import DialogYoyakuDelete from '@/components/DialogYoyakuDelete.vue';
/* eslint-disable */


  export default {
    components:{
        DialogPatientSearch, DialogMonshinnaiyou, DialogSyochinaiyou, DialogYoyakuDelete
    },

    computed: {
        ...mapGetters(['user', 'user_name', 'is_admin']),
    },

    // datas
    data(){
    return {

          // for snackbar
          reserve_id: null,
          dialogDelete: false,
          title: '',
          snackbar: false,
          snackbar_text: '登録完了しました',
          dic_doctor: [],

          patient_id: null,
          edit_mode: false,

          valid: false,
          menu1: '',
          menu2: '',
          time: '',
          bangou: '',

          sei: '',
          mei: '',
          sei_kana: '',
          mei_kana: '',

          sex: null,
          unit_selected: null,
          status_selected: '予約',
          tantou_selected: 0,
          tel: '',
          phone: '',
          mail: '',
          memo: '',

          date_selected: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
          birthday: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

          start_selected: null,
          end_selected: null,
          start: ['','09:00', '09:15', '09:30', '09:45', '10:00', '10:15', '10:30', '10:45', '11:00', '11:15', '11:30', '11:45', '12:00', '12:15', '12:30', '12:45', '13:00', '13:15', '13:30', '13:45', '14:00', '14:15', '14:30', '14:45', '15:00', '15:15', '15:30', '15:45', '16:00', '16:15', '16:30', '16:45', '17:00', '17:15', '17:30', '17:45', '18:00', '18:15', '18:30', '18:45', '19:00'],
          end: [],

          unit: ['1', '2', '3', '4', '5', 'A', 'B'],
          status: ['予約', '受付', '診察', '会計済', 'キャンセル'],

          monshin: null,   // 問診内容ダイアログから渡る
          syochi: null,    // 処置内容ダイアログから渡る


    }},  // datas

    created () {
        console.log('%ccreated: ReserveView.vue', mycolor.created);
      console.log(this.$route);
      if( this.$route.params && this.$route.params.patient_id ){
//      alert('データ引き継ぎ確認');
        this.patient_id = this.$route.params.patient_id;
        this.unit_selected = this.$route.params.unit;
        this.start_selected = this.$route.params.start;
        this.end_selected = this.$route.params.end;
        this.date_selected = this.$route.params.date;
      }

      // マスをクリックしてやってきたとき
      if( this.$route.params && this.$route.params.masuno ){
      console.log('マスをクリック');
//      alert('debug');
        this.end = this.start;
        this.unit_selected = this.unit[this.$route.params.unitno];
        this.start_selected = this.start[this.$route.params.masuno-36];
        this.end_selected = this.end[this.$route.params.masuno-34];
        this.date_selected = this.$route.params.startDate;
        console.log('unit_selected',this.unit_selected);
        console.log('start_selected',this.start_selected);
        console.log('end_selected',this.end_selected);
        console.log('date_selected',this.date_selected);
      }



        console.log(this.$route.name);
        if( this.$route.name==='reserve_update'){
            let reserve_id = this.$route.path.replace('/reserve/', '');
            console.log(reserve_id);
            console.log('来院情報編集');
            this.title = '来院情報編集';
            this.edit_mode = true;
            this.reserve_id = reserve_id;
        }

      this.test();
      // 担当医の辞書を取得
      axios.get('/get_doctors')
        .then((res) => {
                console.group();
                console.log('%c /get_doctors', mycolor.api);
                console.log('担当医のリスト取得');
                console.log('res: ', res.data);
                console.groupEnd();

                for(let i=0; i<res.data.length; i++){
                    if(res.data[i].doctor==='担当医不明・特に希望しない'){
                        res.data[i].doctor = '未選択'
                    }
                }
                this.dic_doctor = res.data;
        })
        .catch(() => {
          // eslint-disable-next-line
          console.error();
        });


      this.initialize();
    },

    methods: {
        test(){
            console.log('test()');
            console.log(this.getArrayTimes());
        },
        add_minutes(dt, minutes) {
            let d = new Date(dt);
            return new Date(d.getTime() + minutes*60000);
        },


        getArrayTimes(is_end){
            let dt = is_end ? `${this.date_selected} ${this.start_selected}` : `${this.date_selected} 09:00` ;
            let loop_times = is_end ? 4*2 : 4*24;
            let myarray = is_end ? [`${this.start_selected}`] : ['09:00'];
            let time_str = '';
            for(let i=0; i<loop_times; i++){
                dt = this.add_minutes(dt, 15);

                time_str = (dt.getHours()+'').padStart(2, '0') + ':' + (dt.getMinutes()+'').padStart(2, '0');
                myarray.push(time_str);
                if( time_str==='19:00'){
                    break;
                }
            }
            return myarray;
        },


        endSelect(){
            console.log('endSelect()');
            console.log(this.date_selected);
            console.log(this.start_selected);


            if( !this.start_selected ){
                console.log('先に開始時間を選択してください.');
                this.end = [];
                return false;
            }
            this.end = this.getArrayTimes(true);
        },


            catchFromDialog(e){
                console.log('受け取りました');
                console.log(e);
                this.records = e;
            },

          initialize () {

            this.start = this.getArrayTimes();
            console.log('initialize');
            console.log(this.$route);


              if(this.patient_id){

                // 患者情報取得して反映
                axios.get('/patient/'+this.patient_id)
                  .then((res) => {
                    console.log(res);
                    let ret = res.data[0];
                    console.log(ret);

                    this.bangou = ret.bangou;
                    this.mei = ret.mei;
                    this.mei_kana = ret.mei_kana;
                    this.sei = ret.sei;
                    this.sei_kana = ret.sei_kana;
                    this.sex = ret.sex;
                    this.birthday = ret.birthday;
                    this.tel = ret.tel;
                    this.phone = ret.phone;
                    this.mail = ret.mail;
                    this.tantou_selected = ret.doctor - 0;  // 型変換

                    this.snackbar = true;
                    this.snackbar_text = `${ret.sei} ${ret.mei} 様の情報を反映しました。`;

                  })
                  .catch(() => {
                    // eslint-disable-next-line
                    console.error();
                  });

              }else if( this.edit_mode ){
                // 予約情報取得して反映
                axios.get( '/reserve/' + this.reserve_id )
                  .then((res) => {

                      console.group();
                      console.log('%c %s', mycolor.api, '/reserve');
                      console.log(res.data);
                      console.groupEnd();


                      let ret = res.data;
                      // todo: 予約idが存在しない場合の処理
                      if(ret===null){
                          location.href='/reserve/';
                      }

                      this.unit_selected = ret.unit;
                      this.status_selected = ret.status;
                      this.bangou = ret.bangou;
                      this.mei = ret.mei;
                      this.mei_kana = ret.mei_kana;
                      this.sei = ret.sei;
                      this.sei_kana = ret.sei_kana;
                      this.sex = ret.sex;
                      this.date_selected = ret.date;
                      this.birthday = ret.birthday;
                      this.tel = ret.tel;
                      this.phone = ret.phone;
                      this.mail = ret.mail;
                      this.memo = ret.memo;
                      this.start_selected = ret.start;
                      this.end.push(ret.end);
                      this.end_selected = ret.end;
                      this.tantou_selected = ret.doctor - 0;  // 型変換

//                    this.snackbar = true;
//                    this.snackbar_text = `予約情報を反映しました。`;

                  })
                  .catch(() => {
                    // eslint-disable-next-line
                    console.error();
                  });

              }
            },  // initialize()



        submit(){
            // 予約登録
            let valid = this.$refs.form.validate()
            console.log(valid);
            if(!valid){
                let alert_text = "下記項目が未入力です。\n\n";
                if(!this.start_selected){
                    alert_text += '開始予定時刻\n';
                }
                if(!this.end_selected){
                    alert_text += '終了予定時刻\n';
                }
                if(!this.unit_selected){
                    alert_text += 'ユニット\n';
                }
                if(!this.sei){
                    alert_text += '姓\n';
                }
                if(!this.mei){
                    alert_text += '名\n';
                }
                if(!this.sei_kana){
                    alert_text += 'セイ\n';
                }
                if(!this.mei_kana){
                    alert_text += 'メイ\n';
                }
                if(!this.tantou_selected){
                    alert_text += '担当医\n';
                }
                alert(alert_text);
                return false;
            }


            /* eslint-disable */
            // todo: バリデーションすること
            var yes = false;
            if(!!this.mail){
                yes = confirm("確認メールを送信しますか?\n"+this.mail);
            }
            /* eslint-disable */

            console.log(yes);

            let data = {
                unit: this.unit_selected,
                status: this.status_selected,
                bangou: this.bangou,
                mei: this.mei,
                mei_kana: this.mei_kana,
                sei: this.sei,
                sei_kana: this.sei_kana,
                sex: this.sex,
                date: this.date_selected,
                birthday: this.birthday,
                tel: this.tel,
                phone: this.phone,
                mail: this.mail,
                memo: this.memo,
                start: this.start_selected,
                end: this.end_selected,
                doctor: this.tantou_selected,
                is_sendmail: true,
                monshin: this.monshin,
                syochi: this.syochi,
            };

            console.log('data', data);


            // todo: 問診内容と処置内容を登録
            axios.post('/reserve_touroku', data)
              .then((res) => {
                    console.group();
                    console.log('%c %s', mycolor.api, '/reserve_touroku');
                    console.log(res.data);
                    console.groupEnd();

                    if(res.data.msg==='reserved'){
                        this.snackbar_text = `下記時間帯で予約が埋まってます。<br><br>${res.data.text}`
                        this.snackbar = true
                        return false;
                    }
                    if(res.data.status==='NG'){
                        alert('登録に失敗しました。');
                        return false;
                    }

                    this.$router.push( '/reservecalendar/'+this.date_selected.replace(/-/mg, '') ).catch(()=>{});
              })
              .catch(() => {
                    // eslint-disable-next-line
                    console.error();
                    alert('登録に失敗しました。');
              });

        },  // submit()

        submit_monshin(data){
            this.monshin = data;

            console.log('%c submit_monshin', mycolor.strong);
            console.log(this.monshin);

            if(this.reserve_id===null){
                return false;
            }

            axios.post('/reserve_update_monshin/' + this.reserve_id, data)
              .then((res) => {
                console.log(res.data);

                if( /lastid=/.test(res.data) ){
                    this.snackbar_text = `問診内容を保存しました`
                    this.snackbar = true
                }

              })
              .catch(() => {
                // eslint-disable-next-line
                console.error();
              });

        },  // submit_monshin()

        submit_syochi(data){
            this.syochi = data;

            console.log('%c submit_syochi', mycolor.strong);
            console.log(this.syochi);

            if(this.reserve_id===null){
                return false;
            }

            axios.post('/reserve_update_syochi/' + this.reserve_id, data)
              .then((res) => {
                console.log(res);

                if( /lastid=/.test(res.data) ){
                    this.snackbar_text = `処置内容を保存しました`
                    this.snackbar = true
                }

              })
              .catch(() => {
                // eslint-disable-next-line
                console.error();
              });

        },  // submit_syochi

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${year}/${month}/${day}` //表示形式のカスタム
        },
        parseDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('/')
            return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
        },


        update(){
            console.log('----------');
            console.log('update()');


            let data = {
                unit: this.unit_selected,
                status: this.status_selected,
                bangou: this.bangou,
                mei: this.mei,
                mei_kana: this.mei_kana,
                sei: this.sei,
                sei_kana: this.sei_kana,
                sex: this.sex,
                date: this.date_selected,
                birthday: this.birthday,
                tel: this.tel,
                phone: this.phone,
                mail: this.mail,
                memo: this.memo,
                start: this.start_selected,
                end: this.end_selected,
                doctor: this.tantou_selected,
            };
            console.log(data);

            if(data.status==='キャンセル'){
                let ret = window.confirm('患者にキャンセルメールを送りますか？')
                let is_sendmail = ret ? true : false;

                axios.get('/reserve_cancel/'+this.reserve_id+'?is_sendmail='+is_sendmail, data)
                  .then((res) => {
                    console.group();
                    console.log('%c %s', mycolor.api, '/reserve_cancel'+this.reserve_id);
                    console.log('res: ', res.data);
                    console.groupEnd();
                    location.href = '/reservecalendar';

                  })
                  .catch(() => {
                    // eslint-disable-next-line
                    console.error();
                  });
                return false;
            }

            const path = '/reserve_update/'+this.reserve_id;
            axios.post(path, data)
              .then((res) => {
                console.log(res);
                if(res.data==='NG'){
                    alert('重複する予約があります！');
                    return false;
                }

                this.$router.go(-1);

              })
              .catch(() => {
                // eslint-disable-next-line
                console.error();
              });

            return false;
        },
        deleteItem(item){
            console.log(item);
            this.dialogDelete = true
        },
        closeDelete () {
          this.dialogDelete = false
        },
        deleteItemConfirm () {
          console.log('deleteItemConfirm');
          console.log( this.$route );
          let reserve_id = this.$route.params.id;

          let data = {};
          data['reserve_id'] = reserve_id;

          let url = '/reserve_delete';
          axios.post(url, data)
            .then((res) => {
              console.log(res);
              this.$router.push('/reservelist');
            })
            .catch(()=>{});

          this.closeDelete()
        },

    },  // methods

  }


</script>


<style scoped>
.mycard{
  height: 1384px;
}
.myform .row{
  max-height: 100px;
}
/*
.container{
  border: 1px solid green;
}
.row{
  border: 1px solid red;
}
.col{
  border: 1px solid blue;
}
*/
/deep/ .v-input__append-inner{
    margin: 0 !important;
    margin: auto !important;
}
/deep/ fieldset{
    background: #fff;
}
/deep/ .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
    height: 48px;
}
/deep/ .v-text-field.v-textarea:not(.v-text-field--rounded) > .v-input__control > .v-input__slot{
    height: unset !important;
}
/deep/ .row + .row{
    margin-top: 0px;
}
/deep/ .v-list-item__content{
    text-align: left;
}
/deep/ .v-text-field .v-label{
    line-height: 14px !important;
}
/deep/ .btn_group > div{
    display: inline-block;
    width: 124px;
    margin-right: 18px;
}
/deep/ .btn_group button{
    width: 124px;
}
/deep/ .v-snack--vertical .v-snack__wrapper{
    flex-direction: row !important;
    flex-wrap: wrap !important;
    justify-content: space-between !important;
    margin-top: 84px;
    min-width: unset;
    padding: 0 20px;
}
/deep/ .v-snack__content{
    padding: 0px !important;
    margin-right: 30px;
}
/deep/ .v-snack--vertical .v-snack__wrapper .v-snack__action{
    margin: 0 !important;
    align-self: unset !important;
}
/deep/ .v-snack:not(.v-snack--has-background) .v-snack__wrapper{
    border: none !important;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%);
}
</style>
